import { ModuleFE_DiseaseValue } from './ModuleFE_DiseaseValue.js';
export const ModulePackFE_DiseaseValueDB = [ModuleFE_DiseaseValue];
//# sourceMappingURL=module-pack.js.map